import { CONFIG } from '../../core/config';
import { ViewModel } from '../view-model';

export class OrgTreeNodeModelRunInput implements ViewModel {
  public readonly friendlyTypeNameSingular = 'Org Tree Node Model Run Input';
  public readonly apiRoute: string;

  orgTreeNodeModelRunInputId: string;
  orgTreeNodeModelRunId: string;
  nodeInputId: string;
  modelNodeId: string;
  value: string;
  displayValue: string;
  displayValueUomId: string;

  public json(): any {
    return this;
  }

  public loadFromJson(data) {
    this.orgTreeNodeModelRunInputId = data.orgTreeNodeModelRunInputId;
    this.orgTreeNodeModelRunId = data.orgTreeNodeModelRunInputId;
    this.nodeInputId = data.nodeInputId;
    this.modelNodeId = data.modelNodeId;
    this.value = data.value;
    this.displayValue = data.displayValue;
    this.displayValueUomId = data.displayValueUomId;
  }
}
